import { global } from '../global';
import { paths, pathnames } from '../../paths';

export const contact = {
  global,
  path: paths.contact,
  pathname: pathnames[paths.contact],
  content: {
    sections: [
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          },
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
        ]
      },
    ]
  }
};
